// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3lIuX","insightsList":"newBusinessInsightsMenu_insightsList__Mk_Ax","active":"newBusinessInsightsMenu_active__1ep5n"};